import { createRouter, createWebHistory } from "vue-router"
import Start from "@/views/Start.vue"
import Tour from "@/views/Tour.vue"

const routes = [
  {
    path: "/",
    name: "Start",
    component: Start,
  },
  {
    path: "/:tour/:station",
    name: "Tour",
    component: Tour,
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
